module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 10.55.35 AM.d672d1bb.jpeg";